import { gsap } from 'gsap';
import '../styles/index.css';
import supportsWebP from 'supports-webp';

// Webp compatibility check

supportsWebP.then((supported) => {
  const bodyTag = document.body;
  if (supported) {
    bodyTag.classList.add('webp');
  } else {
    bodyTag.classList.add('no-webp');
  }
});

// Wheel

function getRotation() {
  currentRotation = Math.round(getter('rotation'));
  tolerance = currentRotation - lastRotation;

  if (Math.round(currentRotation) % (360 / 16) <= tolerance) {
    if (indicator.progress() > 0.3 || indicator.progress() === 0) {
      indicator.play(0);
    }
  }

  lastRotation = currentRotation;
}

const wheel = document.getElementById('wheel');
const ticker = document.getElementById('ticker');
const wheelLogo = document.getElementById('logo-circle');
const playButton = document.getElementById('js-play-button');
const overlay = document.querySelector('.overlay');
const gameWheel = document.querySelector('.game-wheel__svg');
const gameInfo = document.querySelector('.game-info');
const getter = gsap.getProperty(wheel);
const indicator = gsap.timeline();
const spinWheel = gsap.timeline({ paused: true });
const stake = document.getElementById('stake');
const stakeLink = document.getElementById('stake_link');
const stakeError = document.querySelector('.stake-error');
const lights = document.querySelectorAll('.lights');
const overlayStake = document.querySelector('.overlay-stake');
const overlayStakePrizeTen = document.querySelector('.stake-ten-prize');
const overlayHundredSpins = document.querySelector(
  '.overlay-box__text_hundred'
);
const overlayRoshCoins = document.querySelector('.overlay-rosh-coins');
const overlayRoshTwoHundredFiftyCoins = document.querySelector(
  '.overlay-box__text_two_hundred_fifty_coins'
);
const overlayRoshFiftyCoins = document.querySelector(
  '.overlay-box__text_fifty_coins'
);
const errorOverlay = document.querySelector('.error-overlay');
const errorOverlayReplay = document.querySelector('.error-overlay-replay');
const errorOverlayIssue = document.querySelector('.error-overlay-error');
const errorOverlayLogout = document.querySelector(
  '.error-overlay-error-logout'
);
const errorOverlayErrorCodeText = document.querySelector(
  '.error-overlay-error-code-text'
);
const errorOverlayErrorCode = document.querySelector(
  '.error-overlay-error-code'
);
const errorOverlayErrorValue = document.querySelector(
  '.error-overlay-error-value'
);
const congratulationsTitle = document.querySelector(
  '.overlay-box__title_congratulations'
);
const monroClaimButton = document.querySelector('.overlay-box__button_monro');
const solClaimButton = document.querySelector('.overlay-box__button_sol');
const roshplayClaimButton = document.querySelector(
  '.overlay-box__button_roshplay'
);
const vavadaClaimButton = document.querySelector('.overlay-box__button_vavada');
const thanksTitle = document.querySelector('.overlay-box__title_thanks');
const overlayStakeFinal = document.querySelector('.overlay-stake-final');
const overlaySpins = document.querySelector('.overlay-spins');
const closeButton = document.querySelectorAll('.overlay-close-button');
let currentRotation;
let lastRotation;
let tolerance;
let spinToRevolution;
let headers = {};
let wheelPlayData = [];

const domains = JSON.parse(process.env.FRAME_DOMAINS);

function handleMessage(event) {
  if (!domains.includes(event.origin)) {
    showErrorOverlay(-1, event.origin);
    return;
  }
  const value = event.data;
  if (!value.a_id) {
    console.log('a_id', value.a_id);
    showErrorOverlay(-2, value.a_id);
    return;
  }
  intialiseWheel(value.a_id, event.origin);
}
window.addEventListener('message', handleMessage, { once: true });

function intialiseWheel(value, eventOrigin) {
  console.log(eventOrigin);
  let usernameHeader = value + ':';

  headers = {
    Authorization: 'Basic ' + btoa(usernameHeader),
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  fetch(process.env.WHEEL_URL, {
    method: 'GET',
    headers: headers,
  })
    .then((response) => {
      if (!response.ok) {
        return Promise.reject(response);
      }
      return response.json();
    })
    .then((data) => {
      wheelPlayData = data;

      window.parent.postMessage(
        { key: 'game-ready', value: true },
        eventOrigin
      );
      debugLog('Game Ready', eventOrigin);

      playButton.addEventListener('click', function () {
        playButton.disabled = true;
        fetch(wheelPlayData.links.play, {
          method: 'POST',
          headers: headers,
        })
          .then((response) => {
            if (!response.ok) {
              return Promise.reject(response);
            }
            return response.json();
          })
          .then((data) => {
            window.parent.postMessage(
              {
                key: 'game-played',
                value: wheelPlayData.data.id,
              },
              eventOrigin
            );
            debugLog('Game Played', eventOrigin);

            wheelPlayData = data.data[0];

            let wheelResult = 0;

            const tenStake = '78bb81ba-56c9-4a91-8129-0d1eebc1bd13';
            const hundredSpinsMonro = 'a85c0208-b823-45e4-9ce7-ac5679e364fe';
            const hundredSpinsSol = '86b0dbb0-102a-4fd1-865e-620d7a6a097e';
            const twoHundredFiftyRoshCoins =
              '44600b30-549d-4d4a-86dd-cd01bca0c896';
            const fiftyRoshCoins = 'd1951c86-2856-492d-9a34-8c25226c268e';
            const hundredSpinsVavada = 'fd2d9032-a61d-4483-97db-28d09c75e553';

            if (wheelPlayData) {
              switch (wheelPlayData.id) {
                case tenStake:
                  spinToRevolution = 2035;
                  wheelResult = 1;
                  break;
                case hundredSpinsMonro:
                  spinToRevolution = 2148;
                  wheelResult = 2;
                  break;
                case hundredSpinsSol:
                  spinToRevolution = 2058;
                  wheelResult = 3;
                  break;
                case fiftyRoshCoins:
                  spinToRevolution = 2012;
                  wheelResult = 4;
                  break;
                case hundredSpinsVavada:
                  spinToRevolution = 2102;
                  wheelResult = 5;
                  break;
                case twoHundredFiftyRoshCoins:
                  spinToRevolution = 2125;
                  wheelResult = 6;
                  break;
              }
            } else {
              spinToRevolution = 2280;
              wheelResult = 6;
            }

            spinWheel.to(wheel, {
              duration: 5,
              rotation: spinToRevolution,
              transformOrigin: '50% 50%',
              force3D: false,
              ease: 'power4.easeOut',
              onUpdate: getRotation,
              onComplete() {
                setTimeout(() => {
                  gsap.fromTo(
                    lights,
                    {
                      webkitFilter: 'brightness(0.3)',
                      filter: 'brightness(0.3)',
                    },
                    {
                      duration: 0.5,
                      webkitFilter: 'brightness(4)',
                      filter: 'brightness(4)',
                      yoyo: true,
                      repeat: -1,
                      ease: 'none',
                    }
                  );
                  gameWheel.classList.add('dim');
                  gameInfo.classList.add('dim');

                  switch (wheelResult) {
                    case 1:
                      overlay.classList.add('overlay--visible');
                      overlay.classList.add('fade-in');
                      overlayStake.style.display = 'block';
                      overlayStakePrizeTen.style.display = 'block';
                      validateStake();
                      break;
                    case 2:
                      overlay.classList.add('overlay--visible');
                      overlay.classList.add('fade-in');
                      overlaySpins.style.display = 'block';
                      overlayHundredSpins.style.display = 'block';
                      monroClaimButton.style.display = 'flex';
                      break;
                    case 3:
                      overlay.classList.add('overlay--visible');
                      overlay.classList.add('fade-in');
                      overlaySpins.style.display = 'block';
                      overlayHundredSpins.style.display = 'block';
                      solClaimButton.style.display = 'flex';
                      break;
                    case 4:
                      overlay.classList.add('overlay--visible');
                      overlay.classList.add('fade-in');
                      overlayRoshCoins.style.display = 'block';
                      overlayRoshFiftyCoins.style.display = 'block';
                      roshplayClaimButton.style.display = 'flex';
                      break;
                    case 5:
                      overlay.classList.add('overlay--visible');
                      overlay.classList.add('fade-in');
                      overlaySpins.style.display = 'block';
                      overlayHundredSpins.style.display = 'block';
                      vavadaClaimButton.style.display = 'flex';
                      break;
                    case 6:
                      overlay.classList.add('overlay--visible');
                      overlay.classList.add('fade-in');
                      overlayRoshCoins.style.display = 'block';
                      overlayRoshTwoHundredFiftyCoins.style.display = 'block';
                      roshplayClaimButton.style.display = 'flex';
                      break;
                  }
                }, 1000);
              },
            });
            spinWheel.play().timeScale(1);
            indicator.timeScale(1).seek(0);
          })
          .catch((error) => {
            console.error(error);
          });
      });
    })
    .catch((err) => {
      console.log(err);
      showErrorOverlay(err.status, false);
    });
}

closeButton.forEach((closeLinks) => {
  closeLinks.addEventListener('click', clickCloseOverlay);
});

function clickCloseOverlay() {
  const modalClose = {
    key: 'cta-url',
    value: null,
  };
  window.parent.postMessage(modalClose, '*');
}

function debugLog(message, eventOrigin) {
  window.parent.postMessage({ key: 'log', value: message }, eventOrigin);
}

function validateStake() {
  const minimumCharacters = 1;
  const maximumCharacters = 20;

  stakeLink.addEventListener('click', function (e) {
    e.preventDefault();

    let typedStakeUsernameLength = stake.value.length;
    let typedStakeUsername = JSON.stringify({ username_stake: stake.value });

    if (
      typedStakeUsernameLength >= minimumCharacters &&
      typedStakeUsernameLength <= maximumCharacters
    ) {
      fetch(wheelPlayData.links.play, {
        method: 'POST',
        body: typedStakeUsername,
        headers: headers,
      })
        .then((response) => {
          if (!response.ok) {
            return Promise.reject(response);
          }
          return response.json();
        })
        .then(() => {
          congratulationsTitle.style.display = 'none';
          overlayStake.style.display = 'none';
          thanksTitle.style.display = 'block';
          overlayStakeFinal.style.display = 'block';
        })
        .catch((error) => {
          console.error(error);
        });
    } else {
      stakeError.textContent = 'Please enter a valid stake username';
      stakeError.className = 'error active';
    }
  });
}

function showErrorOverlay(errorCode, errorValue) {
  errorOverlay.classList.add('overlay--visible');
  errorOverlay.classList.add('fade-in');

  switch (errorCode) {
    case 429:
      errorOverlayReplay.style.display = 'block';
      break;
    case -1:
      errorOverlayIssue.style.display = 'block';
      errorOverlayErrorCodeText.style.display = 'block';
      errorOverlayErrorCode.textContent = '-1';
      errorOverlayErrorValue.innerHTML = errorValue;
      break;
    case -2:
      errorOverlayLogout.style.display = 'block';
      errorOverlayErrorCodeText.style.display = 'block';
      errorOverlayErrorCode.textContent = '-2';
      errorOverlayErrorValue.innerHTML = errorValue;
      break;
    default:
      errorOverlayIssue.style.display = 'block';
      break;
  }
}

gsap.from(wheel, {
  transformOrigin: '50% 50%',
  scale: 0,
});
gsap.to(wheel, {
  duration: 1.5,
  rotation: 360,
  transformOrigin: '50% 50%',
  ease: 'power4.easeOut',
  scale: 1,
  onComplete() {
    gameWheel.classList.add('game-wheel--visible');
    ticker.classList.add('ticker--visible');
    ticker.classList.add('fade-in');
    wheelLogo.classList.add('logo-circle--visible');
    wheelLogo.classList.add('fade-in');
    gameInfo.classList.add('game-info--visible');
    gameInfo.classList.add('fade-in');
  },
});

indicator
  .to(ticker, {
    duration: 0.13,
    rotation: -10,
    transformOrigin: '65% 36%',
    ease: 'power1.easeOut',
  })
  .to(ticker, {
    duration: 0.13,
    rotation: 3,
    transformOrigin: '65% 36%',
    ease: 'power1.easeOut',
  });

// Carousel

const slides = document.querySelectorAll('.carousel-prize');
const container = document.querySelector('#carousel-inner');
let dots = document.querySelector('.dots');
let oldSlide = 0;
let activeSlide = 0;
let navDots = [];
let duration = 0.6;
let offsets = [];
let ih = window.innerHeight;
let slideDelay = 3;
let timer = gsap.delayedCall(slideDelay, autoPlay);

for (let i = 0; i < slides.length; i++) {
  let newDot = document.createElement('div');
  newDot.className = 'dot';
  newDot.index = i;
  navDots.push(newDot);
  newDot.addEventListener('click', slideAnim);
  dots.appendChild(newDot);
  offsets.push(-slides[i].offsetTop);
}

const dotAnim = gsap.timeline({ paused: true });
dotAnim.to(
  '.dot',
  {
    stagger: { each: 1, yoyo: true, repeat: 1 },
    scale: 0.5,
    rotation: 0.1,
    ease: 'none',
  },
  0.5
);
dotAnim.time(1);

window.addEventListener('load', newSize);
timer.restart(true);

function slideAnim(e) {
  timer.restart(true);

  oldSlide = activeSlide;

  if (this && this.className === 'dot') {
    activeSlide = this.index;
  } else {
    if (e === slides.length) {
      e = 0;
    }
    activeSlide = e;
  }

  activeSlide = activeSlide < 0 ? 0 : activeSlide;
  activeSlide =
    activeSlide > slides.length - 1 ? slides.length - 1 : activeSlide;
  if (oldSlide === activeSlide) {
    return;
  }

  gsap.to(container, duration, {
    y: offsets[activeSlide],
    ease: 'power2.inOut',
    onUpdate: tweenDot,
  });
}

window.addEventListener('resize', newSize);

function newSize() {
  offsets = [];
  ih = window.innerHeight;
  gsap.set('#carousel-inner', { height: slides.length / ih });
  gsap.set(slides, { height: ih });
  for (let i = 0; i < slides.length; i++) {
    offsets.push(-slides[i].offsetTop);
  }
  gsap.set(container, { y: offsets[activeSlide] });
}

function tweenDot() {
  gsap.set(dotAnim, {
    time: activeSlide + 1,
  });
}

function autoPlay() {
  slideAnim(activeSlide + 1);
}

// Track events

(function () {
  document.querySelectorAll('[data-message]').forEach((element) => {
    element.addEventListener('click', () => {
      window.parent.postMessage(element.dataset.message, '*');
    });
  });
})();
